module.exports = __webpack_public_path__ + "static/img/banber (1).341725af.png";